import { gsap } from "gsap";

// hamburger button
const menuButton = document.querySelector('.navbar-toggler');
menuButton.addEventListener('click', function (event) {
    const mobileMenu = document.getElementById('navbarNavDropdown');
    if (mobileMenu.classList.contains('show')) {
        mobileMenu.classList.remove('show');
    } else {
        mobileMenu.classList.add('show');
    }
});

// handle global fade in animation
const toBeAnimated = document.querySelectorAll('.twd_fade_in');
const fadeOptions = {
    threshold: .2,
};

const appearOnScroll = new IntersectionObserver((entries, appearOnScroll) => {
    entries.forEach((entry, i) => {
        if (!entry.isIntersecting) {
            return;
        } else {
            gsap.to(entry.target, { opacity: 1, y: 0, duration: .75, delay: 0.2*i })
            appearOnScroll.unobserve(entry.target);
        }
    })
}, fadeOptions);

toBeAnimated.forEach(element => {
    appearOnScroll.observe(element);
});

// promotion banner animation
document.addEventListener('DOMContentLoaded', function () {
    const footerPromotion = document.querySelector('.footer-promotion');
    const footer = document.querySelector('footer');

    setTimeout(() => {
        footerPromotion.classList.add('visible');
    }, 500);

    function checkScrollPosition() {
        const footerTop = footer.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;

        if (footerTop < windowHeight) {
            footerPromotion.classList.add('above-footer');
        } else {
            footerPromotion.classList.remove('above-footer');
        }
    }

    window.addEventListener('scroll', checkScrollPosition);
    checkScrollPosition();
});
